var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3198_4868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.523731 14.5172C0.662844 14.6658 1.30805 15.0859 1.57143 15.0859C2.09524 15.0859 1.37388 15.0859 1.57143 15.0859C2.37911 15.0859 2.90137 14.2106 3.44856 13.6165L9.14078 7.4364C9.67605 6.85525 10.2099 5.9866 11 5.9866C11.79 5.9866 12.3238 6.85521 12.859 7.43629L19.1438 14.2598C19.3002 14.4296 19.4757 14.5613 19.6789 14.6708C20.1454 14.9225 20.7078 14.9458 21.171 14.688C21.1924 14.6762 21.2131 14.6646 21.233 14.6535C21.3943 14.5635 21.5449 14.4519 21.654 14.3029C21.8514 14.0336 22 13.7059 22 13.3798C22 12.9609 21.7548 12.5395 21.4761 12.2424L14.1428 4.28049C13.301 3.38967 12.1896 3.14308 10.9999 3.14308C9.81025 3.14308 8.69881 3.38967 7.85706 4.28049L0.523731 12.2424C0.24502 12.5395 -1.69822e-07 12.9609 -1.332e-07 13.3798C-9.65779e-08 13.7987 0.24502 14.2201 0.523731 14.5172Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3198_4868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "currentColor",
    transform: "translate(22 22) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/arrow-top.22fe18de90550ffeae7fd8d85db19c17.svg";
export { ForwardRef as ReactComponent };